<template>
    <!-- 状態遷移を表示 -->
    <div class="container header-margin mx-auto">
        <div class="row state">
            <div class="col-md-2 active">送付先入力　→</div>
            <div class="col-md-2">個数指定　→</div>
            <div class="col-md-2">確認画面　→</div>
            <div class="col-md-2">お支払い</div>
        </div>

        <div class="title">
            <h4 class="h4 font-weight-normal text-primary text-center mb-0">
                注文者及び送付先の情報入力
            </h4>
        </div>

        <div class="text-left">
            <p>※特殊文字は使用できません。</p>
            <p>※確実にお届けするため、必ずフルネームを入力ください。</p>
            <p>※私書箱や空港内の窓口へのお届けは承っておりません。</p>
            <p>※コンビニ、営業所、空港の宅配サービスカウンターなどの住所を入力すると商品をお受け取りいただけません。</p>
        </div>

        <form class="row form py-3" @submit.prevent="handleOnSubmit">
            <div class="col-md-6 col-sm-12 order-form">
                <div class="form-row">
                    <div class="col-md-6">
                        <h4>注文者情報の入力</h4>
                    </div>
                </div>
                
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_name">氏名：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="text" class="form-control form-control-sm" id="order_name"
                                @change="onOrderNameChange"
                                v-model="formData.order_name" v-bind:class="{ 'is-invalid': errors.order_name}"/>
                    </div>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_company_name">会社名：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="text" class="form-control form-control-sm" id="order_company_name"
                                @change="onOrderCompanyNameChange"
                                v-model="formData.order_company_name" v-bind:class="{ 'is-invalid': errors.order_company_name}"/>
                    </div>
                    <small class="form-text text-muted">※オプション</small> 
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_post_number">郵便番号：</label>
                    </div>
                    <div class="col-md-9">
                        <div class="form-row">
                            <div class="col-4">
                                <input type="number" class="form-control form-control-sm" id="order_post_number_1" size="4"
                                @change="onOrderPostNumber1Change"
                                v-model="formData.order_post_number_1" v-bind:class="{ 'is-invalid': errors.order_post_number_1}"/>
                            </div>
                            <div class="col-1 text-center"> - </div>
                            <div class="col-4">
                                <input type="number" class="form-control form-control-sm" id="order_post_number_2" size="5"
                                @change="onOrderPostNumber2Change"
                                        v-model="formData.order_post_number_2" v-bind:class="{ 'is-invalid': errors.order_post_number_2}"/>
                            </div>
                            <div class="col-3">
                                <a v-on:click.stop="auto_fill_order_address" class="btn btn-sm btn-primary btn-block">住所入力</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_address_1">住所１：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="text" class="form-control form-control-sm" id="order_address_1"
                                @change="onOrderAddress1Change"
                                v-model="formData.order_address_1" v-bind:class="{ 'is-invalid': errors.order_address_1}"/>
                    </div>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_address_2">住所２：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="text" class="form-control form-control-sm" id="order_address_2"
                                @change="onOrderAddress2Change"
                                v-model="formData.order_address_2" v-bind:class="{ 'is-invalid': errors.order_address_2}"/>
                    </div>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_phone_number">電話番号：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="number" class="form-control form-control-sm" id="order_phone_number"
                                @change="onOrderPhoneNumberChange" max="99999999999" minlength="10"
                                v-model="formData.order_phone_number" v-bind:class="{ 'is-invalid': errors.order_phone_number}"/>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 forwarding-form">
                <div class="form-row">
                    <div class="col-md-6">
                        <h4>送付先情報の入力</h4>
                    </div>
                    <div class="col-md-6">
                        <input type="checkbox" id="copy" v-on:click="copy" v-model="formData.copy"> <label for="copy">注文者と同じ</label>
                    </div>
                </div>

                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_forwarding_name">氏名：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="text" class="form-control form-control-sm" id="order_forwarding_name"
                                v-bind:disabled="formData.copy"
                                v-model="formData.order_forwarding_name" v-bind:class="{ 'is-invalid': errors.order_forwarding_name}"/>
                    </div>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_forwarding_company_name">会社名：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="text" class="form-control form-control-sm" id="order_forwarding_company_name"
                                v-bind:disabled="formData.copy"
                                v-model="formData.order_forwarding_company_name" v-bind:class="{ 'is-invalid': errors.order_forwarding_company_name}"/>
                    </div>
                    <small class="form-text text-muted">※オプション</small>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_forwarding_post_number">郵便番号：</label>
                    </div>
                    <div class="col-md-9">
                        <div class="form-row">
                            <div class="col-4">
                                <input type="number" class="form-control form-control-sm" id="order_forwarding_post_number_1" size="4"
                                        v-bind:disabled="formData.copy"
                                        v-model="formData.order_forwarding_post_number_1" v-bind:class="{ 'is-invalid': errors.order_forwarding_post_number_1}"/>
                            </div>
                            <div class="col-1 text-center"> - </div>
                            <div class="col-4">
                                <input type="number" class="form-control form-control-sm" id="order_forwarding_post_number_2" size="5"
                                        v-bind:disabled="formData.copy"
                                        v-model="formData.order_forwarding_post_number_2" v-bind:class="{ 'is-invalid': errors.order_forwarding_post_number_2}"/>
                            </div>
                            <div class="col-3">
                                <a v-on:click.stop="auto_fill_order_forwarding_address" class="btn btn-sm btn-block"
                                    v-bind:class="[!formData.copy ? 'btn-primary' : 'btn-secondary']" 
                                    v-bind:disabled="formData.copy">住所入力</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_forwarding_address_1">住所１：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="text" class="form-control form-control-sm" id="order_forwarding_address_1"
                                v-bind:disabled="formData.copy"
                                v-model="formData.order_forwarding_address_1" v-bind:class="{ 'is-invalid': errors.order_forwarding_address_1}"/>
                    </div>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_forwarding_address_2">住所２：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="text" class="form-control form-control-sm" id="order_forwarding_address_2"
                                v-bind:disabled="formData.copy"
                                v-model="formData.order_forwarding_address_2" v-bind:class="{ 'is-invalid': errors.order_forwarding_address_2}"/>
                    </div>
                </div>
                <div class="form-row m-3">
                    <div class="col-md-3">
                        <label for="order_forwarding_phone_number">電話番号：</label>
                    </div>
                    <div class="col-md-9">
                        <input type="number" class="form-control form-control-sm" id="order_forwarding_phone_number"
                                v-bind:disabled="formData.copy" max="99999999999"
                                v-model="formData.order_forwarding_phone_number" v-bind:class="{ 'is-invalid': errors.order_forwarding_phone_number}"/>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div class="form-row justify-content-center" v-if="errors" >
                    <div class="col-md-12">
                        <ul>
                            <li class="text-danger col col-12 text-left text-md-center" v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </div>
                </div>
                
                <div class="form-row py-3 justify-content-center">
                    <div class="text-center">
                        <input type="checkbox" id="privacy_policy" v-model="formData.privacy_policy"> <label for="privacy_policy">プライバシーポリシーに同意する</label>
                    </div>
                </div>

                <div class="form-row py-3 justify-content-center">
                    <div class="col-md-3">
                        <a  href="/" class="text-center">
                            <span class="btn btn-light btn-block">{{ $t('hec.policy.cancelButton') }}</span>
                        </a>
                    </div>

                    <div class="col-md-3 mt-2 mt-md-0">
                        <button v-on:submit.prevent type="submit" class="btn btn-primary btn-block">{{ $t('hec.policy.nextButton') }}</button>
                    </div>
                </div>
            </div>

        </form>
    </div>

</template>

<script>
    import userService from "../../services/UserService";

    import Yubinbango from 'yubinbango-core';

    export default {
        name: 'OrderAddress',

        components: {
        },

        data() {
            return {
                formData: {
                    privacy_policy: false,
                    copy: false,
                    order_name: "",
                    order_company_name: "",
                    order_post_number_1: "",
                    order_post_number_2: "",
                    order_address_1: "",
                    order_address_2: "",
                    order_phone_number: "",
                    order_forwarding_post_number_1: "",
                    order_forwarding_post_number_2: "",
                    order_forwarding_name: "",
                    order_forwarding_company_name: "",
                    order_forwarding_post_number_1: "",
                    order_forwarding_post_number_2: "",
                    order_forwarding_address_1: "",
                    order_forwarding_address_2: "",
                    order_forwarding_phone_number: "",
                },
                errors: [],
                requireAgree: false,
            }
        },

        async created() {
            await this.getDefaultData();
        },

        mounted() {
        },

        methods: {

            copy() {
                this.formData.order_forwarding_name = this.formData.order_name;
                this.formData.order_forwarding_company_name = this.formData.order_company_name;
                this.formData.order_forwarding_post_number_1 = this.formData.order_post_number_1;
                this.formData.order_forwarding_post_number_2 = this.formData.order_post_number_2;
                this.formData.order_forwarding_address_1 = this.formData.order_address_1;
                this.formData.order_forwarding_address_2 = this.formData.order_address_2;
                this.formData.order_forwarding_phone_number = this.formData.order_phone_number;
            },

            async getDefaultData() {
                const map = new Map(Object.entries(this.formData));

                map.forEach((value, key) => {
                    this.formData[key] = sessionStorage.getItem(key);
                });
                this.formData.copy = sessionStorage.copy === 'true' ? true : false;
            },

            async saveData() {
                const map = new Map(Object.entries(this.formData));

                map.forEach((value, key) => {
                    let new_value = "";

                    if (value !== null) {
                        new_value = value;
                    }

                    sessionStorage.setItem(key, new_value);
                });
            },

            async auto_fill_order_address() {
                let _this = this;

                let zip = this.formData.order_post_number_1 + this.formData.order_post_number_2;

                new Yubinbango.Core(zip, function(addr) {
                    console.log(addr);
                    
                    _this.formData.order_address_1 = addr.region + addr.locality + addr.street; // 都道府県ID

                    if(_this.formData.copy) {
                        _this.formData.order_forwarding_address_1 = _this.formData.order_address_1;
                    }
                });
            },

            async auto_fill_order_forwarding_address() {
                if(this.formData.copy) return;
                let _this = this;

                let zip = this.formData.order_forwarding_post_number_1 + this.formData.order_forwarding_post_number_2;

                new Yubinbango.Core(zip, function(addr) {
                    _this.formData.order_forwarding_address_1 = addr.region + addr.locality + addr.street; // 都道府県ID
                });

            },

            async handleOnSubmit(e) {

                this.requireAgree = false;

                this.errors = [];

                this.saveData();
                
                if (!this.formData.privacy_policy) {
                    this.errors.push(this.$t('order.address.privacy_policy_required'));
                }
                
                if (!this.formData.order_name) {
                    this.errors.push(this.$t('order.address.name_required'));
                }
                
                if (!this.formData.order_post_number_1) {
                    this.errors.push(this.$t('order.address.order_post_number_1_required'));
                }
                
                if (!this.formData.order_post_number_2) {
                    this.errors.push(this.$t('order.address.order_post_number_2_required'));
                }
                
                if (!this.formData.order_address_1) {
                    this.errors.push(this.$t('order.address.order_address_1_required'));
                }
                
                if (!this.formData.order_phone_number) {
                    this.errors.push(this.$t('order.address.order_phone_number_required'));
                }
                
                if (this.formData.order_phone_number.length < 10) {
                    this.errors.push(this.$t('order.address.order_phone_number_min_length'));
                }
                
                if (!this.formData.order_forwarding_name) {
                    this.errors.push(this.$t('order.address.order_forwarding_name_required'));
                }
                
                if (!this.formData.order_forwarding_post_number_1) {
                    this.errors.push(this.$t('order.address.order_forwarding_post_number_1_required'));
                }
                
                if (!this.formData.order_forwarding_post_number_2) {
                    this.errors.push(this.$t('order.address.order_forwarding_post_number_2_required'));
                }
                
                if (!this.formData.order_forwarding_address_1) {
                    this.errors.push(this.$t('order.address.order_forwarding_address_1_required'));
                }
                
                if (!this.formData.order_forwarding_phone_number) {
                    this.errors.push(this.$t('order.address.order_forwarding_phone_number_required'));
                }

                if (this.errors.length == 0) {
                    this.$router.push('/dna/amount');
                }
            },
            
            async onOrderNameChange(e) {
                if (this.formData.copy) {
                    this.formData.order_forwarding_name = this.formData.order_name;
                }
            },

            async onOrderCompanyNameChange(e) {
                if(this.formData.copy) {
                    this.formData.order_forwarding_company_name = this.formData.order_company_name;
                }
            },

            async onOrderPostNumber1Change(e) {
                if(this.formData.copy) {
                    this.formData.order_forwarding_post_number_1 = this.formData.order_post_number_1;
                }
            },

            async onOrderPostNumber2Change(e) {
                if(this.formData.copy) {
                    this.formData.order_forwarding_post_number_2 = this.formData.order_post_number_2;
                }
            },

            async onOrderAddress1Change(e) {
                if(this.formData.copy) {
                    this.formData.order_forwarding_address_1 = this.formData.order_address_1;
                }
            },

            async onOrderAddress2Change(e) {
                if(this.formData.copy) {
                    this.formData.order_forwarding_address_2 = this.formData.order_address_2;
                }
            },

            async onOrderPhoneNumberChange(e) {
                if(this.formData.copy) {
                    this.formData.order_forwarding_phone_number = this.formData.order_phone_number;
                }
            }

        },
        computed: {}
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .title {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .form {
        padding-top: 15px;
    }

    .btn-primary {
        color: #FFF !important;
    }

    .order-form {
        border-right: 1px solid #333;
    }

    .state {
        padding-bottom: 10px;
        
        color: #888;
    }

    .state .active {
        color: #451493;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    /* Firefox */
    input[type=number] {
    -moz-appearance: textfield;
    }
</style>
